// functions used to locally update fetched data after update, instead of fetching again

const addItem = (items, newItem) => {
  const added = [...items, newItem];
  return added;
};

// doesn't change order of original items
const updateItem = (items, newItem, compareProp = "_id") => {
  return items.map((item) =>
    item[compareProp] === newItem[compareProp] ? newItem : item,
  );
};

const deleteItem = (items, deletedItem, compareProp = "_id") => {
  const removed = items.filter(
    (item) => item[compareProp] !== deletedItem[compareProp],
  );
  return removed;
};

export { addItem, updateItem, deleteItem };
